import { Box, IBoxProps } from 'native-base';
import React, { ReactNode } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { DEFAULT_PADDING } from 'app/components/ResponsiveContainer';
import { tID } from 'app/services/TestHelper';

export type FixedBottomProps = IBoxProps & {
  children?: ReactNode;
  padded?: boolean;
};

export default function FixedBottom({ children, padded, ...props }: FixedBottomProps) {
  const { bottom } = useSafeAreaInsets();
  return (
    <Box
      bottom={`${bottom}px`}
      left="0"
      position="absolute"
      px={padded ? DEFAULT_PADDING : undefined}
      py={padded ? DEFAULT_PADDING : undefined}
      right="0"
      testID={tID('FixedBottom')}
      w="full"
      {...props}
    >
      {children}
    </Box>
  );
}
